import 'htmx.org'
import { WidgetInstance } from 'friendly-challenge'

// Campaign page: sticky donation block
function initSliders() {
  document.querySelectorAll<HTMLElement>('[data-slider]').forEach((slider) => {
    const track = slider.querySelector<HTMLElement>('[data-slider-track]')
    const dots = slider.querySelectorAll<HTMLElement>('[data-slider-dot]')
    const prevBtn = slider.querySelector<HTMLElement>('[data-slider-prev]')
    const nextBtn = slider.querySelector<HTMLElement>('[data-slider-next]')
    if (!track || dots.length === 0) return

    let current = 0
    const total = dots.length

    const goTo = (index: number) => {
      current = (index + total) % total
      track.style.transform = `translateX(-${current * 100}%)`
      dots.forEach((dot, i) => {
        dot.classList.toggle('w-6', i === current)
        dot.classList.toggle('bg-white', i === current)
        dot.classList.toggle('w-2', i !== current)
        dot.classList.toggle('bg-white/50', i !== current)
      })
    }

    prevBtn?.addEventListener('click', () => goTo(current - 1))
    nextBtn?.addEventListener('click', () => goTo(current + 1))
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)))

    let touchStartX = 0
    let touchStartY = 0
    let touchTracking = false

    track.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.touches[0].clientX
        touchStartY = e.touches[0].clientY
        touchTracking = true
      },
      { passive: true }
    )

    track.addEventListener(
      'touchend',
      (e) => {
        if (!touchTracking) return
        touchTracking = false
        const deltaX = e.changedTouches[0].clientX - touchStartX
        const deltaY = e.changedTouches[0].clientY - touchStartY
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return
        goTo(deltaX < 0 ? current + 1 : current - 1)
      },
      { passive: true }
    )
  })
}

function initCampaignPage() {
  initSliders()
  const observer = new IntersectionObserver(
    ([entry]) => {
      const stickyBlock = document.getElementById('donation-cta-fixed')

      if (stickyBlock) {
        stickyBlock.classList.toggle('hidden', entry.isIntersecting)
      }
    },
    { threshold: 0 }
  )

  const donationCtaRelative = document.getElementById('donation-cta-relative')

  if (donationCtaRelative) {
    observer.observe(donationCtaRelative)
  }

  // Campaign description show more/less toggle
  const descriptionToggle = document.querySelector('[data-description-toggle]')
  const descriptionContent = document.querySelector('.description-content')

  if (descriptionToggle && descriptionContent) {
    const showMoreText = descriptionToggle.getAttribute('data-show-more') || 'Show more'
    const showLessText = descriptionToggle.getAttribute('data-show-less') || 'Show less'

    descriptionToggle.addEventListener('click', () => {
      const isExpanded = descriptionContent.getAttribute('data-expanded') === 'true'

      if (isExpanded) {
        descriptionContent.classList.add('line-clamp-5')
        descriptionContent.setAttribute('data-expanded', 'false')
        descriptionToggle.textContent = showMoreText
      } else {
        descriptionContent.classList.remove('line-clamp-5')
        descriptionContent.setAttribute('data-expanded', 'true')
        descriptionToggle.textContent = showLessText
      }
    })
  }

  // Animate progress bars on load
  const progressBars = document.querySelectorAll('[data-progress]')
  progressBars.forEach((bar) => {
    const targetProgress = bar.getAttribute('data-progress')
    if (targetProgress) {
      // Small delay to ensure the transition happens
      setTimeout(() => {
        ;(bar as HTMLElement).style.width = `${targetProgress}%`
      }, 100)
    }
  })

  // Donation carousel auto-rotation
  const donationCarousels = document.querySelectorAll('[data-donation-carousel]')
  console.log('carousel')
  donationCarousels.forEach((carousel) => {
    const items = carousel.children
    const totalItems = items.length
    let currentIndex = 0

    if (totalItems > 1) {
      setInterval(() => {
        currentIndex = (currentIndex + 1) % totalItems
        const offset = currentIndex * -24 // -24px (h-6 = 1.5rem = 24px)
        ;(carousel as HTMLElement).style.transform = `translateY(${offset}px)`
      }, 5000)
    }
  })

  // Share link copy button
  const copyButton = document.querySelector('[data-copy-share-link]')
  if (copyButton) {
    copyButton.addEventListener('click', () => {
      const shareLink = document.getElementById('share-link') as HTMLInputElement
      const successMessage = document.getElementById('copy-success-message')

      if (shareLink) {
        navigator.clipboard.writeText(shareLink.value).then(() => {
          if (successMessage) {
            successMessage.classList.remove('hidden')
            setTimeout(() => {
              successMessage.classList.add('hidden')
            }, 3000)
          }
        })
      }
    })
  }

  // Facebook share button
  const facebookShareButton = document.querySelector('[data-facebook-share]')
  if (facebookShareButton) {
    facebookShareButton.addEventListener('click', () => {
      const shareUrl = facebookShareButton.getAttribute('data-facebook-share')
      if (shareUrl) {
        window.open(shareUrl, 'facebook-share-dialog', 'width=626,height=436')
      }
    })
  }

  // WhatsApp share button
  const whatsappShareButton = document.querySelector('[data-whatsapp-share]')
  if (whatsappShareButton) {
    whatsappShareButton.addEventListener('click', () => {
      const shareText = whatsappShareButton.getAttribute('data-whatsapp-share')
      if (shareText) {
        // Detect if mobile/tablet to use appropriate WhatsApp URL
        const isMobileOrTablet = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
        const whatsappUrl = `https://${isMobileOrTablet ? 'api' : 'web'}.whatsapp.com/send?text=${shareText}`
        window.open(whatsappUrl)
      }
    })
  }

  // LinkedIn share button
  const linkedinShareButton = document.querySelector('[data-linkedin-share]')
  if (linkedinShareButton) {
    linkedinShareButton.addEventListener('click', () => {
      const shareUrl = linkedinShareButton.getAttribute('data-linkedin-share')
      if (shareUrl) {
        window.open(shareUrl, 'linkedin-share-dialog', 'width=626,height=436')
      }
    })
  }

  // Instagram share button (copies link to clipboard and triggers shareable image generation)
  const instagramShareButton = document.querySelector('[data-instagram-share]')
  if (instagramShareButton) {
    const testFile = new File([], 'test.png', { type: 'image/png' })
    const canShare = navigator.canShare && navigator.canShare({ files: [testFile] })

    const fallbackPanel = document.getElementById('instagram-fallback-panel')
    const shareGrid = document.getElementById('instagram-share-grid')
    const openInstagramBtn = document.getElementById('instagram-fallback-open')
    const downloadBtn = document.getElementById('instagram-fallback-download') as HTMLAnchorElement

    if (canShare) {
      instagramShareButton.addEventListener('click', () => {
        const imageUrl = instagramShareButton.getAttribute('data-image-url')

        document.getElementById('share-modal-description')?.classList.add('hidden')
        document.getElementById('instagram-fallback-instructions')?.classList.add('hidden')
        document.getElementById('instagram-can-share-instructions')?.classList.remove('hidden')
        fallbackPanel?.classList.remove('hidden')
        fallbackPanel?.classList.add('flex')
        shareGrid?.classList.add('hidden')
        downloadBtn?.classList.add('hidden')

        const shareContent = instagramShareButton.getAttribute('data-instagram-share')
        if (shareContent) {
          navigator.clipboard.writeText(shareContent).catch(() => {})
        }

        if (imageUrl) {
          fetch(imageUrl)
            .then(async (res) => ({ status: res.status, data: await res.blob() }))
            .then(({ status, data }) => {
              const loadingEl = document.getElementById('instagram-fallback-loading')
              const imgEl = document.getElementById('instagram-fallback-image') as HTMLImageElement

              loadingEl?.classList.add('hidden')

              if (status !== 200) {
                document.getElementById('instagram-fallback-error')?.classList.remove('hidden')
                return
              }

              if (status === 200) {
                const file = new File([data], 'shareable-image.png', { type: 'image/png' })
                const blobUrl = URL.createObjectURL(data)

                if (imgEl) {
                  imgEl.src = blobUrl
                  imgEl.classList.remove('hidden')
                }

                if (openInstagramBtn && navigator.canShare && navigator.canShare({ files: [file] })) {
                  openInstagramBtn.addEventListener(
                    'click',
                    (e) => {
                      e.preventDefault()
                      navigator.share({ files: [file] })
                    },
                    { once: true }
                  )
                }
              }
            })
        } else {
          document.getElementById('instagram-fallback-loading')?.classList.add('hidden')
        }
      })
    } else {
      // Fallback for browsers without Web Share API file support
      instagramShareButton.addEventListener('click', () => {
        fallbackPanel?.classList.remove('hidden')
        fallbackPanel?.classList.add('flex')
        shareGrid?.classList.add('hidden')
        document.getElementById('share-modal-description')?.classList.add('hidden')

        const generateImageUrl = instagramShareButton.getAttribute('data-generate-image-url')
        const imageUrl = instagramShareButton.getAttribute('data-image-url')

        if (generateImageUrl && imageUrl) {
          fetch(imageUrl)
            .then(async (res) => ({ status: res.status, data: await res.blob() }))
            .then(({ status, data }) => {
              if (status === 200) {
                const blobUrl = URL.createObjectURL(data)
                const loadingEl = document.getElementById('instagram-fallback-loading')
                const imgEl = document.getElementById('instagram-fallback-image') as HTMLImageElement
                const downloadBtn = document.getElementById('instagram-fallback-download') as HTMLAnchorElement

                loadingEl?.classList.add('hidden')
                if (imgEl) {
                  imgEl.src = blobUrl
                  imgEl.classList.remove('hidden')
                }
                if (downloadBtn) {
                  downloadBtn.href = blobUrl
                  downloadBtn.classList.remove('hidden')
                }
              } else {
                document.getElementById('instagram-fallback-loading')?.classList.add('hidden')
                document.getElementById('instagram-fallback-error')?.classList.remove('hidden')
              }
            })
        } else {
          document.getElementById('instagram-fallback-loading')?.classList.add('hidden')
        }
      })
    }
  }

  // Reset share modal state when dialog closes
  const shareModal = document.getElementById('share-modal') as HTMLDialogElement
  if (shareModal) {
    shareModal.addEventListener('close', () => {
      document.getElementById('copy-success-message')?.classList.add('hidden')

      const fallbackPanel = document.getElementById('instagram-fallback-panel')
      fallbackPanel?.classList.add('hidden')
      fallbackPanel?.classList.remove('flex')

      document.getElementById('instagram-share-grid')?.classList.remove('hidden')
      document.getElementById('share-modal-description')?.classList.remove('hidden')
      document.getElementById('instagram-fallback-instructions')?.classList.remove('hidden')
      document.getElementById('instagram-can-share-instructions')?.classList.add('hidden')

      const loadingEl = document.getElementById('instagram-fallback-loading')
      loadingEl?.classList.remove('hidden')

      document.getElementById('instagram-fallback-error')?.classList.add('hidden')

      const imgEl = document.getElementById('instagram-fallback-image') as HTMLImageElement
      if (imgEl) {
        imgEl.classList.add('hidden')
        imgEl.src = ''
      }

      const downloadBtn = document.getElementById('instagram-fallback-download') as HTMLAnchorElement
      if (downloadBtn) {
        downloadBtn.classList.add('hidden')
        downloadBtn.href = '#'
      }
    })
  }

  // Native share button (uses Web Share API)
  const nativeShareButton = document.querySelector('[data-native-share]')
  if (nativeShareButton) {
    if (!navigator.share) {
      ;(nativeShareButton as HTMLElement).style.display = 'none'
    }

    nativeShareButton.addEventListener('click', () => {
      const shareUrl = nativeShareButton.getAttribute('data-native-share')
      const shareTitle = nativeShareButton.getAttribute('data-native-share-title')

      if (shareUrl && navigator.share) {
        navigator
          .share({
            title: shareTitle || 'GoodCrowd',
            url: shareUrl,
          })
          .catch((error) => {
            // User cancelled the share or share failed
            console.log('Share failed:', error)
          })
      }
    })
  }

  // Initialize Friendly Captcha for inquiry modal
  const captchaContainer = document.querySelector('.frc-captcha:not(.denunciation-captcha)') as HTMLElement
  if (captchaContainer) {
    const sitekey = captchaContainer.getAttribute('data-sitekey')
    if (sitekey) {
      new WidgetInstance(captchaContainer, {
        sitekey: sitekey,
        startMode: 'focus',
        doneCallback: (solution: string) => {
          const hiddenField = document.getElementById('inquiry_captcha_solution') as HTMLInputElement
          if (hiddenField) {
            hiddenField.value = solution
          }
        },
      })
    }
  }

  // Initialize Friendly Captcha for denunciation modal
  const denunciationCaptchaContainer = document.querySelector('.frc-captcha.denunciation-captcha') as HTMLElement
  if (denunciationCaptchaContainer) {
    const sitekey = denunciationCaptchaContainer.getAttribute('data-sitekey')
    if (sitekey) {
      new WidgetInstance(denunciationCaptchaContainer, {
        sitekey: sitekey,
        startMode: 'focus',
        doneCallback: (solution: string) => {
          const hiddenField = document.getElementById('denunciation_captcha_solution') as HTMLInputElement
          if (hiddenField) {
            hiddenField.value = solution
          }
        },
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', initCampaignPage)
document.addEventListener('htmx:afterSwap', (event) => {
  if ((event as CustomEvent).detail.target === document.body) {
    initCampaignPage()
  }
})
